/**
 * Pause button tools.
 */
H_Tools.pause = (() => {
    /**
     * Sets the button state of the supplied pause button.
     *
     * @param {*} button A pause button element (or a nearby element)
     * @param {*} paused If `true` the button state will be set to paused, if `false` the button
     *                   state will be set to play
     */
    function state(button, paused) {
        if (!button) {
            return;
        }

        // if we are given an element that isn't the button element, find the button element
        if (button.tagName !== 'BUTTON') {
            button = button
                ?.closest('.js-pause-button-video-wrapper')
                ?.querySelector('.js-pause-button');
        }

        if (!button) {
            return;
        }

        button.classList.toggle('-playing', paused);
        button.classList.toggle('-paused', !paused);

        let text = button.querySelector('.js-pause-button-text');

        if (!text) {
            return;
        }

        text.innerText = button.getAttribute(
            'data-text-' + (paused ? 'pause' : 'play')
        );
    }

    // Return an object to expose inner functions
    return {
        state: state,
    };
})();
